import React from 'react'

const Manual_regalo_tienda_puntos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear regalo para tienda de puntos
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_regalo_para_tienda_de_puntos__t7afL-ZzTfyRDg7xLlSW0g?as=scrollable"
          className="scribe-iframe-general-144"
          width="100%"
          height="10800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_regalo_tienda_puntos
